import {
    FETCH_PATIENTS_REQUEST,
    FETCH_PATIENTS_SUCCESS,
    FETCH_PATIENTS_FAILURE,
    SET_PATIENTS_PAGE,
    SET_PATIENTS_PAGE_SIZE,
  } from '../actions/PatientActions'
  
  const initialState = {
    loading: false,
    patients: [],
    totalPatients: 0,
    page: 1,
    pageSize: 10,
    error: null,
  };
  
  const patientReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PATIENTS_REQUEST:
        return { ...state, loading: true };
      case FETCH_PATIENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          patients: action.payload.patients,
          totalPatients: action.payload.totalPatients,
        };
      case FETCH_PATIENTS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_PATIENTS_PAGE:
        return { ...state, page: action.payload };
      case SET_PATIENTS_PAGE_SIZE:
        return { ...state, pageSize: action.payload, page: 1 };
      default:
        return state;
    }
  };
  
  export default patientReducer;
  